module.exports = __webpack_public_path__ + "img/point_exchange.ea1e36bb.svg";